@for (announcement of announcements; track announcement) {
  @if (announcement.visible) {
    <div class="announcement">
      @if (announcement.link) {
        <a class="link-announcement" [routerLink]="announcement.link">
          {{ announcement.message }}
        </a>
      }
      @if (!announcement.link) {
        <span>{{ announcement.message }}</span>
      }
      <i
        class="material-icons"
        (click)="$event.preventDefault(); announcement.visible = false"
      >
        close
      </i>
    </div>
  }
}

<mat-toolbar role="heading" class="zeva-header">
  <div class="left-header">
    <!-- <div class="sidenav-trigger" (click)="toggleSidenav()">
      <mat-icon>{{ sidenavService.opened ? 'close' : 'menu' }}</mat-icon>
    </div> -->
    <div class="sidenav-logo-container">
      @switch (logo) {
        @case ('default') {
          <img
            [src]="theme.isDarkMode ? '/assets/zeva-logo-dm.webp' : '/assets/zeva-logo.webp'"
            class="sidenav-logo"
            alt="ZEVA Global"
          />
        }
        @case ('white') {
          <img src="/assets/zeva-logo-white.svg" class="sidenav-logo" />
        }
      }
    </div>

    @if (showTelemetryPrereqs) {
      <div class="telemetry-notice">
        <div style="display: flex; align-items: center">
          <mat-icon> warning_amber </mat-icon>
          <div class="telemetry-info">
            <p>{{ 'header.telemetryNotice' | transloco }}</p>
            <a (click)="telemetryPopup()">{{ 'header.view' | transloco }}</a>
          </div>
        </div>
      </div>
    }
  </div>

  <div class="right-header">
    @if (quickAccessTemplate !== undefined) {
      <div class="quick-access">
        <ng-container *ngTemplateOutlet="quickAccessTemplate"></ng-container>
      </div>
      <mat-divider [vertical]="true" />
    }

    <!-- <button
      mat-flat-button
      color="primary"
      [routerLink]="'/admin/manage-subscription'"
      *ngIf="subscriptionService.isFreePlan$ | async"
      style="margin-right: 1rem"
      >
      Upgrade to Premium
    </button> -->

    @if (!!user && !!account) {
      <!-- ZEBOT -->
      @if (showAlan && (user.is_superuser || account.data_type === 'FM')) {
        <button
          matIconButton
          trackElement="Alan"
          [trackEvents]="['click', 'mouseenter', 'mouseleave']"
          (click)="zebotCont.toggle(); zebot.startChat()"
        >
          <mat-icon svgIcon="zebot" class="th-color-primary"></mat-icon>
        </button>
      }

      <!-- Account Management Menu -->
      <div
        class="header-account"
        cdkOverlayOrigin
        [popoverTriggerFor]="menuOverlay"
        >
        <div class="full">
          <span class="name">
            {{ user.first_name }}
            @if (user.last_name) {
              {{ user.last_name }}
            }
          </span>
          <!-- Show account name if FM & SI account is selected -->
          @if (account && account.data_type !== AccountType.IN) {
            <div
              class="account th-color-secondary-text"
              >
              <span class="subscript">{{ 'header.account' | transloco }}</span>
              {{ account.company_name }}
            </div>
          }
          <!-- Show user Email if IN account or no account is selected -->
          @if (!account || account.data_type === AccountType.IN) {
            <div
              class="account th-color-secondary-text"
              >
              <span class="subscript">{{ user.email }}</span>
            </div>
          }
        </div>
        <span class="short">
          <mat-icon>person_outline</mat-icon>
        </span>
      </div>

      <shared-popover
        #menuOverlay
        backdropClass="cdk-overlay-dark-backdrop"
        alignmentX="end"
        >
        <div class="zeva-card elevated account-menu">
          @if (accounts.length > 1) {
            <button
              mat-button
              [trackElement]="account ? 'Change Account' : 'Select Account'"
              [trackEvents]="['click', 'mouseenter', 'mouseleave']"
              (click)="onChangeAccount()"
              >
              <mat-icon>transit_enterexit</mat-icon>
              <span>{{
                account ? ('header.changeAccount' | transloco) : ('header.selectAccount' | transloco)
              }}</span>
            </button>
          }
          <button
            mat-button
            routerLink="/admin/profile"
            trackElement="Preferences"
            [trackEvents]="['click', 'mouseenter', 'mouseleave']"
            >
            <mat-icon>tune</mat-icon>
            <span>{{ 'header.preferences' | transloco }}</span>
          </button>
          <!-- <mat-divider></mat-divider> -->
          <button
            mat-button
            trackElement="Help"
            [trackEvents]="['click', 'mouseenter', 'mouseleave']"
            (click)="supportClick()"
            >
            <mat-icon>contact_support</mat-icon>
            <span>{{ 'header.help' | transloco }}</span>
          </button>
          <!-- <mat-divider></mat-divider> -->
          <button
            mat-button
            trackElement="Feedback"
            [trackEvents]="['click', 'mouseenter', 'mouseleave']"
            (click)="feedbackClick()"
            >
            <mat-icon>feedback</mat-icon>
            <span>{{ 'header.feedback' | transloco }}</span>
          </button>
          <!-- <mat-divider></mat-divider> -->
          <button
            mat-button
            trackElement="Sign Out"
            [trackEvents]="['click', 'mouseenter', 'mouseleave']"
            (click)="onSignOut()"
            >
            <mat-icon>logout</mat-icon>
            <span>{{ 'header.signOut' | transloco }}</span>
          </button>
        </div>
      </shared-popover>
    }
  </div>
</mat-toolbar>
